module.exports = __webpack_public_path__ + "static/disko-act-77eb124330eb84319713c57e4d971919.png";